type Translate = (key: string) => string;

const periodKeys: Array<[string, string]> = [
  ["TODAY", "report.periodToday"],
  ["THISWEEK", "report.periodThisWeek"],
  ["THISMONTH", "report.periodThisMonth"],
  ["THISFISCALQUARTER", "report.periodThisFiscalQuarter"],
  ["THISFISCALYEAR", "report.periodThisFiscalYear"],
  ["FIRSTSIXMONTH", "report.periodFirstSixMonths"],
  ["LASTSIXMONTH", "report.periodLastSixMonths"],
  ["JAN", "report.month1"],
  ["FEB", "report.month2"],
  ["MAR", "report.month3"],
  ["APR", "report.month4"],
  ["MAY", "report.month5"],
  ["JUN", "report.month6"],
  ["JUL", "report.month7"],
  ["AUG", "report.month8"],
  ["SEP", "report.month9"],
  ["OCT", "report.month10"],
  ["NOV", "report.month11"],
  ["DEC", "report.month12"],
  ["FISCALQUARTER1", "report.fiscalQuarter1"],
  ["FISCALQUARTER2", "report.fiscalQuarter2"],
  ["FISCALQUARTER3", "report.fiscalQuarter3"],
  ["FISCALQUARTER4", "report.fiscalQuarter4"],
  ["LASTWEEK", "report.periodLastWeek"],
  ["LASTMONTH", "report.periodLastMonth"],
  ["LASTFISCALQUARTER", "report.periodLastFiscalQuarter"],
  ["LASTFISCALYEAR", "report.periodLastFiscalYear"],
];

export const getReportPeriodOptions = (t: Translate) =>
  periodKeys.map(([value, key]) => ({ value, label: t(key) }));

export const getInvoiceFormOptions = (t: Translate) => [
  { value: "1", label: t("report.vatInvoiceForm") },
  { value: "2", label: t("report.salesInvoiceForm") },
  { value: "5", label: t("report.electronicTicketForm") },
];
